// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"Diagnose_gridContainer__2jnjq"};